import React from "react";
import * as ObjectExtensions from "../../../../../utils/CoreExtensions/ObjectExtensions";
import clsx from "clsx";

const rowInfo = (title, number, tooltip, isHeader = false, displayInfoInRows = false) => {
  return (
    <div className={clsx({
      'font-600': isHeader,
      'flex flex-gap-5 justify-content-between': !displayInfoInRows
    })}>
      <div>
        {tooltip || title}
      </div>
      <div>
        {number}
      </div>
    </div>
  );
};

const ChartTooltip = (props) => {
  const displayInfoInRows = props.displayInfoInRows || false;

  return (
    <div className='flex flex-column bg-white p-2'>
      { rowInfo(props.name, props.y, props.tooltip, true, displayInfoInRows) }
      {
        ObjectExtensions.map(props.roleBasedSplit || {}, ([role, count]) => {
          return (
            <React.Fragment key={role}>
              {rowInfo(props.translationMap[role].term, count)}
            </React.Fragment>
          )
        })
      }
    </div>
  );
};

export default ChartTooltip;